"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isZubehoerModel = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const isZubehoerModel = (whatever) => {
    return (0, echain_shared_ts_utils_1.isDefinedObject)(whatever) && whatever['ArticleType'] === echain_product_models_1.ArticleType.zubehoer;
};
exports.isZubehoerModel = isZubehoerModel;
//# sourceMappingURL=ZubehoerModel.js.map